import { useShallow } from "zustand/react/shallow";

import { PageName } from "analytics/events";
import { useLayoutStore } from "app/stores/useLayoutStore";
import { BOTTOM_TAB_BAR_HEIGHT_NUMBER } from "ui/BottomTabBarContainer";

import { EndDroppingProcessButton } from "./EndDroppingProcessButton";
import { useSharedListCreator } from "../stores/useSharedListCreator";

export function SharingPreDropListButton() {
  const { pageName } = useLayoutStore(
    useShallow((state) => ({
      pageName: state.pageName,
    })),
  );

  const bottomHeight =
    pageName === PageName.INBOUND_PAGE_LIST_VERIFICATION ? 0 : BOTTOM_TAB_BAR_HEIGHT_NUMBER;

  const { handleSharingList } = useSharedListCreator();

  return (
    <EndDroppingProcessButton
      shouldShowButton
      onClickButton={handleSharingList}
      labelMessageId="pages.inbound.sharing-pre-drop-list.button"
      bottom={bottomHeight}
    />
  );
}
